addressform<template>
    <div class="page-container">
        <div class="back_left" @click="$router.go(-1)" />
        <!-- <div class="big_tit">
      {{ $t('safe.setting') }}
    </div> -->
        <img style="position: absolute;width: 100%;top: 6%;" src="../images/user/kaihang.jpg" alt="">
        <div class="headers">
            <h1>领取支票</h1>
        </div>

        <div class="imggw">
            <img width="350px" src="../images/user/zhifu.jpg" alt="">
        </div>
        <div class="form-wrapper">
            <form class="card-form">
                <div class="form-title">填写资料</div>
                <!-- <div class="red-text">
          <span style="margin-right: 10px;" @click="$router.push('/records')">资金追回记录▶</span>
          <span @click="$router.push('/hongtou')">红头文件▶</span>
        </div> -->
                <div class="form-group">
                    <label>真实姓名</label>
                    <input v-model="formData.realname" type="text" required placeholder="请输入真实名字">
                </div>

                <div class="form-group">
                    <label>联系电话</label>
                    <input v-model="formData.phoneNumber" type="text" required placeholder="请输入手机号">
                </div>
                <div class="form-group">
                    <label>身份证号</label>
                    <input v-model="formData.realNumber" type="text" required placeholder="请输入身份证号">
                </div>
                <div class="form-group">
                    <label>收货地址</label>
                    <input v-model="formData.addressform" type="text" required placeholder="请输入收货地址">
                </div>
                <!-- <div class="form-group">
          <label>追回金额</label>
          <input v-model="formData.moneyNumber" type="text" required placeholder="请输入追回金额">
        </div> -->

                <!-- <div class="add-card" @click="handleFileUpload">+ 添加卡号</div>
        <div class="tip">请务必在15-30个工作日内提交，提交后相关部门将为您解冻</div> -->
                <!-- <div class="form-groups">
          <label>上传银行卡照片</label>
          <input type="file" @change="handleFileUpload" accept="image/*">
          <div v-if="previewImage" class="preview">
            <img :src="previewImage" alt="银行卡预览">
          </div>
        </div> -->
            </form>
        </div>

        <button v-if="datawudi.receive_status == 1" class="confirm-btn">已领取</button>
        <button v-else-if="datawudi.receive_status == 0" class="confirm-btn" @click="handleSubmit">立即领取</button>

    </div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch'
import {
    DropdownMenu,
    DropdownItem
} from 'vant';

import { Empty } from 'vant';

Vue.use(Empty);
Vue.use(DropdownMenu).use(DropdownItem);
export default {
    data() {
        return {
            datawudi: {},
            formData: {
                realname: '',
                phoneNumber: '',
                realNumber: '',
                addressform: '',
            },
            previewImage: null
        }
    },
    created() {
        this.$parent.footer('user', false);
        // 看个人信息
        this.starts();

    },
    methods: {
        async starts() {
            const r = await Fetch('/user/info');
            this.datawudi = r.data;
        },
        handleSubmit() {
            const remainingCount = 15 - this.datawudi.inviteCount;
            if (remainingCount > 0) {
                this.$toast({
                    className: "toastName",
                    message: `还需要邀请${remainingCount}位好友`
                });
                return;
            }

            if (!this.formData.realname) {
                this.$toast({
                    className: "toastName",
                    message: '真实姓名不能为空'
                });
                return false;
            }
            if (!this.formData.phoneNumber) {
                this.$toast({
                    className: "toastName",
                    message: '手机号不能为空'
                });
                return false;
            }
            const phoneRule = /^1[3-9]\d{9}$/;
            if (!phoneRule.test(this.formData.phoneNumber)) {
                this.$toast({
                    className: "toastName",
                    message: '手机号码格式不正确',
                });
                return false;
            }
            // 身份证号码
            const idcardReg = /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/;
            if (!idcardReg.test(this.formData.realNumber)) {
                this.$toast({
                    className: "toastName",
                    message: '身份证号码格式不正确',
                });
                return false;
            }
            if (!this.formData.realNumber) {
                this.$toast({
                    className: "toastName",
                    message: '身份证不能为空'
                });
                return false;
            }
            if (!this.formData.addressform) {
                this.$toast({
                    className: "toastName",
                    message: '收货地址不能为空'
                });
                return false;
            }



            Fetch('/user/receive_add', {
                ...this.formData
            }).then((res) => {
                // this.$toast({
                //   className: "toastName",
                //   message: '提交成功，请耐心等待！'
                // });
                // console.log(res.info,res.info['zh_cn'],"看看");

                this.$toast({
                    className: "toastName",
                    message: res.info['zh_cn'] ? res.info['zh_cn'] : res.info,
                });
                // this.$router.go(-1);
                // this.$router.push('/records')
            }).catch((err) => {
                this.$toast({
                    className: "toastName",
                    message: err.info
                });
            });

        },

        showDetail() {
            // 明细逻辑
            this.$router.push({
                name: 'moneybag'
            });
        }
    }
}
</script>

<style lang="less" scoped>
.page-container {
    height: 100vh;
    background: url(../images/user/redimg.jpg) no-repeat center;
    background-size: 112% 102%;
    position: relative;
}

.headers {
    color: #f2ffba;
    font-size: 35px;
    position: absolute;
    top: 20%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    text-align: center;
}

.form-wrapper {
    position: absolute;
    top: 72%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80%;
    max-width: 500px;
    background: #fff;
    padding: 0 10px 30px;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.card-form h2 {
    text-align: center;
    margin-bottom: 20px;
}

.form-title {
    width: 200px;
    margin: 0 auto 10px;
    background: #d7000f;
    color: #fff;
    border-radius: 0 0 12px 12px;
    padding: 8px 0;
    font-size: 16px;
    text-align: center;
    margin-bottom: 18px;
    font-weight: bold;
}

.red-text {
    color: #e50113;
    text-align: right;
    margin: 10px 0;
}

.form-group {
    margin-bottom: 20px;
    display: flex;
    justify-content: space-around;
    align-items: center;
}

label {
    display: block;
    /* margin-bottom: 8px; */
}

input {
    width: 80%;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
}

.preview img {
    max-width: 100%;
    max-height: 200px;
    margin-top: 10px;
}

.confirm-btn {
    position: fixed;
    bottom: 50px;
    width: 80%;
    max-width: 500px;
    left: 50%;
    transform: translateX(-50%);
    padding: 12px 40px;
    background: #ffdf9a;
    color: red;
    border: none;
    border-radius: 4px;
    font-size: 18px;
    font-weight: bold;
    cursor: pointer;
}

.add-card {
    display: block;
    width: 100%;
    height: 150px;
    line-height: 150px;
    background: #fff0e0;
    color: #d7000f;
    border: 1px dashed #d7000f;
    border-radius: 6px;
    font-size: 15px;
    text-align: center;
    margin-bottom: 12px;
    cursor: pointer;
}

.tip {
    color: #d7000f;
    font-size: 12px;
    text-align: center;
    margin-top: 8px;
    margin-bottom: 10px;
}

.imggw {
    position: absolute;
    top: 25%;
    left: 50%;
    transform: translateX(-50%);
}

.input-wrapper {
    position: relative;
    width: 80%;
}

.input-wrapper input {
    width: 100%;
    padding-right: 120px;
    /* 留出按钮空间 */
    height: 38px;
    font-size: 16px;
    box-sizing: border-box;
}

.input-btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 66px;
    height: 28px;
    padding: 0 10px;
    background: #e63946;
    color: #fff;
    border: none;
    border-radius: 4px;
    font-size: 13px;
    cursor: pointer;
}

.input-btn.detail {
    right: 8px;
    // background: #888;
}
</style>
